import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { rgba } from 'emotion-rgba';

import { colors } from 'src/styles/colors';
import { ZeeFontBold, ZeeFontMedium, ZeeFontRegular } from 'src/styles/font';
import { MediaBP } from 'src/styles/mediaQuery';
import { flex } from 'src/styles/utils';

export const SubscriptionContainer = styled.div`
  ${flex('column')};
  background-color: ${colors.SubscriptionGrey};
  position: relative;
  width: 100vw;
  height: 100%;
  ${MediaBP.MediaLg} {
    ${flex('row-reverse', 'start', 'start')};
  }
`;

export const SubscriptionContainerNew = styled.div`
  ${flex('column')};
  background-color: ${colors.PrimaryBlackColor};
  position: relative;
  width: 100vw;
  height: 100%;
  ${MediaBP.MediaLg} {
    ${flex('row-reverse', 'start', 'start')};
  }
`;

export const SubscriptionBody = styled.div`
  width: 100%;
  margin-bottom: 80px;
  ${MediaBP.MediaLg} {
    width: 55%;
    flex: 1;
    padding: 32px 3% 0 10%;
    margin-bottom: 0px;

    height: 100vh;
    position: relative;
  }
`;
export const SubscriptionBodyV3 = styled.div`
  width: 100%;
  margin-bottom: 80px;
  ${MediaBP.MediaLg} {
    width: 55%;
    flex: 1;
    padding: 32px 3% 0 10%;
    margin-bottom: 0px;
  }
`;
export const ButtonContainer = styled.div`
  padding: 24px 15px;
  width: 100%;
  border-radius: 16px 16px 0px 0px;
  background: ${colors.SubscriptionGrey};
  box-shadow: 0px 0px 20px 0px ${rgba(colors.black, 0.6)};
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 100;
  ${MediaBP.MediaSm} {
    width: 100%;
  }
  ${MediaBP.MediaLg} {
    position: absolute;
    bottom: 0;
    left: 0;
  }
`;

export const ButtonContainerV3 = styled.div`
  padding: 24px 15px;
  width: 100%;
  border-radius: 16px 16px 0px 0px;
  background: ${colors.SubscriptionGrey};
  box-shadow: 0px 0px 20px 0px ${rgba(colors.black, 0.6)};
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 100;
  ${MediaBP.MediaLg} {
    position: static;
  }
`;

export const SubsDetailContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 16px;
  z-index: 1;
  position: relative;
  background-color: ${colors.Transparent};
  ${MediaBP.MediaSm} {
    padding: 16px 60px;
  }
  ${MediaBP.MediaMd} {
    padding: 16px 120px;
  }
  ${MediaBP.MediaLg} {
    padding: 16px;
  }
`;

export const TOCStyle = styled.div`
  color: ${colors.LightGrayColor};
  position: relative;
  ${ZeeFontRegular(11, 18)};
  width: 100%;
  ${MediaBP.MediaLg} {
    ${ZeeFontRegular(14, 20)};
  }
`;

export const TOCStyleNew = styled.div`
  color: ${colors.LightGrayColor};
  position: relative;
  text-align: center;
  ${ZeeFontRegular(11, 18)};
  width: 100%;
  ${MediaBP.MediaLg} {
    ${ZeeFontRegular(14, 20)};
  }
`;

export const TOCLink = styled.a`
  color: ${colors.Lavender};
`;

export const centerAlign = css`
  text-align: center;
`;
export const ApplyCodeContainer = styled.div`
  border-radius: 8px;
  cursor: pointer;
  border: 1px solid ${colors.BorderGrey};
  padding: 8px 16px;
  width: 100%;
  color: ${colors.PrimaryWhiteColor};
  background: linear-gradient(335deg, #2a272b 22%, #413745 100%);
  box-shadow: 0px 4px 10px 0px ${rgba(colors.black, 0.25)};
  text-align: left;
  align-content: center;
  ${flex('row', 'space-between')};
  ${ZeeFontMedium(12, 18)};
  ${MediaBP.MediaMd} {
    ${ZeeFontRegular(12, 18)};
  }
  ${MediaBP.MediaMd} {
    ${ZeeFontRegular(14, 20)};
  }
  ${MediaBP.MediaMd} {
    ${ZeeFontRegular(16, 24)};
  }
`;

export const ApplyCodeWrapper = styled.div`
  width: 100%;
  padding: 0px 16px;
`;
export const ApplyCodeContainerNew = styled.div`
  border-radius: 8px;
  cursor: pointer;
  border: 1px solid ${colors.BorderGrey};
  padding: 8px 16px;
  width: 100%;
  color: ${colors.PrimaryWhiteColor};
  background: linear-gradient(
    335deg,
    rgba(42, 39, 43, 0.2) 22%,
    rgba(65, 55, 69, 0.2) 100%
  );
  box-shadow: 0px 4px 10px 0px ${rgba(colors.black, 0.25)};
  text-align: left;
  align-content: center;
  ${flex('row', 'space-between')};
  ${ZeeFontMedium(12, 18)};
  ${MediaBP.MediaMd} {
    ${ZeeFontRegular(12, 18)};
  }
  ${MediaBP.MediaMd} {
    ${ZeeFontRegular(14, 20)};
  }
  ${MediaBP.MediaMd} {
    ${ZeeFontRegular(16, 24)};
  }
`;

export const PromoIcon = styled.img`
  width: 24px;
  height: 24px;
`;

export const TextAndIconContainer = styled.div`
  ${flex('row', 'start')};
  width: 100%;
  gap: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const RemovePromoCode = styled.div`
  color: ${colors.inputError};
  cursor: pointer;
`;

export const LoggedInContainer = styled.div`
  color: ${colors.PlanTitleGrey};
  width: 100%;
  border-radius: 8px;
  ${ZeeFontMedium(12, 18)};
  box-shadow: 0px 4px 10px 0px ${rgba(colors.black, 0.25)};
  border: 1px solid ${rgba(colors.white, 0.25)};
  padding: 8px 16px;
  ${flex('row', 'start')};
`;

export const LoggedInAndTocWrapper = styled.div`
  margin-top: 20px;
  margin-bottom: 30px;
`;
export const LoggedInContainerNew = styled.div`
  color: ${colors.PlanTitleGrey};
  width: 100%;
  ${ZeeFontMedium(12, 18)};
  text-align: center;
  padding: 8px 16px;
`;

export const DiscountWrapper = styled.div`
  width: 100%;
  display: flex;
  position: relative;
  bottom: 36px;
  justify-content: center;
`;
export const PlanTitleText = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  ${ZeeFontMedium(10, 18)};
  color: ${colors.PrimaryWhiteColorAlpha80};
  ${MediaBP.MediaSm} {
    ${ZeeFontBold(14, 20)};
  }
`;
